import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography } from 'foundations-library/components'
import { TypographyType, TypographyVariantType } from 'foundations-library/types'
import { getSvg } from './utils'

const useStyles = makeStyles(theme => {
    return {
        root: {
            display: 'flex',
            width: '100%',
            maxWidth: '568px',
            flexDirection: 'column',
            alignItems: 'center',
            fontFamily: 'Inter',
            fontSize: '15px',
            fontWeight: 400,
            gap: 0,
            '&.small-view': {
                boxSizing: 'border-box',
                gap: '20px',
                padding: '0 16px'
            }
        },
        svg: {
            '@media (max-height: 768px)': {
                width: '50%'
            }
        },
        contentContainer: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '10px',
            width: '100%'
        },
        customContentContainer: {
            width: '100%',
            '&.small-view, &.small-view > *': {
                fontFamily: 'Inter',
                fontSize: '12px',
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: '18px',
                textAlign: 'center'
            },
            '&.small-view span, &.small-view a': {
                fontFamily: 'Inter',
                fontSize: '12px',
                fontWeight: 600,
                letterSpacing: 0,
                lineHeight: '19px',
                textAlign: 'center'
            }
        },
        buttonContainer: {
            display: 'flex',
            padding: '30px 0 40px 0',
            justifyContent: 'center',
            alignItems: 'flex-start',
            gap: '20px',
            alignSelf: 'stretch',
            '&.small-view': {
                flexDirection: 'column',
                '& > *': {
                    width: '100%'
                }
            }
        }
    }
})

interface MainProps {
    title?: {
        text: string
        variant?: TypographyVariantType
        color?: TypographyType['color']
    }
    description?: {
        text: string
        variant?: TypographyVariantType
        color?: TypographyType['color']
    }
    svg: {
        name: string
        styles?: React.CSSProperties
    }
    customContent?: React.ReactNode
    buttons?: React.ReactNode[]
    rootStyles?: React.CSSProperties
    contentStyles?: React.CSSProperties
    buttonContainerStyles?: React.CSSProperties
    smallView?: boolean
}

/**
 *
 */
export const Main = ({
    title,
    description,
    svg,
    buttons,
    rootStyles,
    contentStyles,
    buttonContainerStyles,
    customContent,
    smallView = false
}: MainProps) => {
    const classes = useStyles()
    const svgPath = getSvg(svg.name)
    const svgStyles = { ...(svg.styles || {}), ...(smallView ? { width: '150px' } : {}) }

    return (
        <div className={`${classes.root} ${smallView ? 'small-view' : ''}`} style={rootStyles || {}}>
            <img src={svgPath} alt={svg.name || 'SVG image'} width={'100%'} style={svgStyles} className={classes.svg} />
            <div className={classes.contentContainer} style={contentStyles}>

                {title?.text && <Typography
                    variant={smallView ? 'h6' : title.variant || 'h4'}
                    color={title.color}
                    align='center'
                >
                    {title.text}
                </Typography>}
                {description?.text && <Typography
                    variant={smallView ? 'body3' : description.variant || 'body1'}
                    color={description.color}
                    align='center'
                >
                    {description.text}
                </Typography>}

                {customContent && (
                    <div className={`${classes.customContentContainer} ${smallView ? 'small-view' : ''}`}>
                        {customContent}
                    </div>
                )}

                <div className={`${classes.buttonContainer} ${smallView ? 'small-view' : ''}`} style={buttonContainerStyles}>
                    {buttons?.map((button) => button)}
                </div>
            </div>
        </div>
    )
}
